<template>
  <div class="flex">
    <div class="w-1/2 pr-3">
      <div class="my-5">
        <p class="text-xs text-gray-500">{{ $lang.app.INDIVIDUAL_ENTERPRISE_CODE }}</p>
        <p class="min-h-6">{{ individualEnterprise?.individualEnterpriseCode }}</p>
        <hr />
      </div>
      <div class="my-5">
        <p class="text-xs text-gray-500">{{ $lang.app.SURNAME }}</p>
        <p class="min-h-6">{{ individualEnterprise?.surname }}</p>
        <hr />
      </div>
      <div class="my-5">
        <p class="text-xs text-gray-500">{{ $lang.app.NAME }}</p>
        <p class="min-h-6">{{ individualEnterprise?.name }}</p>
        <hr />
      </div>
      <div class="my-5">
        <p class="text-xs text-gray-500">{{ $lang.app.PATRONYMIC }}</p>
        <p class="min-h-6">{{ individualEnterprise?.patronymic }}</p>
        <hr />
      </div>
      <div class="my-5">
        <p class="text-xs text-gray-500">{{ $lang.app.INDIVIDUAL_ENTERPRISE_REGISTER_NUMBER }}</p>
        <p class="min-h-6">{{ individualEnterprise?.registerNumber }}</p>
        <hr />
      </div>
      <div class="my-5">
        <p class="text-xs text-gray-500">{{ $lang.app.ISSUED_DATE }}</p>
        <p class="min-h-6">{{ individualEnterprise?.docDate ? $moment(individualEnterprise?.docDate).format('DD.MM.YYYY') : '' }}</p>
        <hr />
      </div>
      <div class="my-5">
        <p class="text-xs text-gray-500">{{ $lang.app.SERIES }}</p>
        <p class="min-h-6">{{ individualEnterprise?.series }}</p>
        <hr />
      </div>
    </div>
    <div class="w-1/2 pl-3">
      <div class="my-5">
        <p class="text-xs text-gray-500">{{ $lang.app.NUMBER }}</p>
        <p class="min-h-6">{{ individualEnterprise?.number }}</p>
        <hr />
      </div>
      <div class="my-5">
        <p class="text-xs text-gray-500">{{ $lang.app.OKPO }}</p>
        <p class="min-h-6">{{ individualEnterprise?.okpo }}</p>
        <hr />
      </div>
      <div class="my-5">
        <p class="text-xs text-gray-500">{{ $lang.app.INDIVIDUAL_ENTERPRISE_LEGAL_FORM }}</p>
        <p class="min-h-6">{{ individualEnterprise?.legalForm }}</p>
        <hr />
      </div>
      <div class="my-5">
        <p class="text-xs text-gray-500">{{ $lang.app.INDIVIDUAL_ENTERPRISE_FIRST_REGISTER_DATE }}</p>
        <p class="min-h-6">{{ individualEnterprise?.firstRegisterDate ? $moment(individualEnterprise?.firstRegisterDate).format('DD.MM.YYYY') : '' }}</p>
        <hr />
      </div>
      <div class="my-5">
        <p class="text-xs text-gray-500">{{ $lang.app.INDIVIDUAL_ENTERPRISE_LAST_REGISTER_DATE }}</p>
        <p class="min-h-6">{{ individualEnterprise?.lastRegisterDate ? $moment(individualEnterprise?.lastRegisterDate).format('DD.MM.YYYY') : '' }}</p>
        <hr />
      </div>
      <div class="my-5">
        <p class="text-xs text-gray-500">{{ $lang.app.INDIVIDUAL_ENTERPRISE_TAX_CODE_NAME }}</p>
        <p class="min-h-6">{{ individualEnterprise?.taxCodeName }}</p>
        <hr />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    individualEnterprise: Object,
  }
}
</script>